import './index.scss'

type Props = {
  children: React.ReactNode
}

export function Ul({ children }: Props) {
  return <ul className="ul">{children}</ul>
}
